import React from "react";
import DeweyWorkdmark from "../icons/dewey_workdmark";

export default function Attribution() {
  return (
    <div className="dewey--search--attribution">
      <a
        href="https://askdewey.com"
        target="_blank"
        rel="noopener noreferrer"
        className="dewey--search--attribution--link"
      >
        <span className="dewey--search--attribution--text">Powered by</span>
        <DeweyWorkdmark />
      </a>
    </div>
  );
}
